import { fetchCachedHelper } from '../../../api/api'
import { companyLogoActions } from './companyLogoSlice'

export const getLogo = domainName => async dispatch => {
    dispatch(companyLogoActions.getCompanyLogoRequest())
    try {
        const response = await fetchCachedHelper(
            `Customer/GetCompanyLogoByDomainName/${domainName}`
        )
        console.log(response.data)
        dispatch(companyLogoActions.getCompanyLogoRequestSuccess(response.data))
    } catch (e) {
        if (e.response?.status === 404) {
            return dispatch(companyLogoActions.getCompanyLogoRequestError(true))
        }
        dispatch(companyLogoActions.getCompanyLogoRequestError(false))
    }
}
